import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sort-table-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sort-table-header.component.html',
  styleUrl: './sort-table-header.component.scss'
})
export class SortTableHeaderComponent {
  @Input() label: string = '';
  @Input() field: string = '';
  @Input() isNewUI: boolean = false;

  @Input() sortField: string = '';
  @Input() sortOrder: number = 1;
  @Output() sortChange = new EventEmitter<{ field: string, order: number }>();

  onSort() {
    if (!this.field) return;

    let newOrder = 1;
    if (this.field === this.sortField) {
      newOrder = this.sortOrder === 1 ? -1 : 1;
    } else {
      newOrder = 1;
    }
    this.sortChange.emit({
      field: this.field,
      order: newOrder
    });
  }
}
